import {useState} from "react";

const Checkbox = ({checked = false}) => {
    const [check, setCheck] = useState(checked);

    const handleCheck = (e) => {
        setCheck(e.target.checked);
    }

    return(
        <div className={'checkbox round-corner-5'}>
            <input checked={check} onChange={handleCheck} type="checkbox"/>
        </div>
    )
}

export default Checkbox;
